import React, { useState, useEffect } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemButton from '@mui/material/ListItemButton';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import PrintIcon from '@mui/icons-material/Print';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import WebStoriesIcon from '@mui/icons-material/WebStories';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockIcon from '@mui/icons-material/Block';
import MobiledataOffIcon from '@mui/icons-material/MobiledataOff';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import InventoryIcon from '@mui/icons-material/Inventory';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { descargarFactura } from 'actions/archivos';
import { fetchConToken } from 'helpers/fetch';
import SLUGS from 'resources/slugs';
import Swal from 'sweetalert2';

const RenderButtons = (props) => {
  const [path, setPath] = useState(props.colDef.path);
  const [clikFactor, setClikFactor] = useState(1);
  const [clikId, setClikId] = useState(0);
  const [clikClave, setClikClave] = useState('');
  const [clikSucursalId, setClikSucursalId] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [opciones, setOpciones] = useState([]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (props.row?.factor > 0) setClikFactor(props.row.factor);

    if (!props.colDef.validarOpcionesHistorial) {
      setClikId(event.currentTarget.id);
      return;
    }

    if (props.row.movimiento_Id > 0) {
      setClikId(props.row.movimiento_Id);
      return;
    }

    setClikId(0);
    setClikClave(props.row.clave);
    setClikSucursalId(props.row.sucursal_Id);
    switch (props.row.movimiento) {
      case 'ARTICULO':
      case 'ARTICULO_STOCK':
      case 'ARTICULO_PRECIO': {
        if (props.row.articulo && props.row.articulo?.id > 0) setClikId(props.row.articulo?.id);

        return;
      }
      case 'ARTICULO_VARIANTE':
      case 'ARTICULO_VARIANTE_STOCK':
      case 'ARTICULO_VARIANTE_PRECIO': {
        if (props.row.articulo_Variante && props.row.articulo_Variante?.articulo_Id > 0) setClikId(props.row.articulo_Variante?.articulo_Id);

        return;
      }
      case 'VENTA': {
        if (props.row.venta && props.row.venta?.id > 0) {
          setClikId(props.row.venta?.id);
          if (props.row.venta?.no_Orden && props.row.venta?.no_Orden !== undefined && props.row.venta?.no_Orden !== null && props.row.venta?.no_Orden !== '') setClikClave(props.row.venta?.no_Orden);
        }

        return;
      }
      default: break
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const DescargarGuia = (id) => {
    handleClose();
    fetchConToken(`Ventas/DescargarEtiquetaEnvio?venta_id=${id}`).then(async (responseFile) => {
      try {
        if (responseFile.hasOwnProperty('status') && responseFile.status === 400) {
          Object.entries(responseFile.errors).forEach(([, value]) => {
            Swal.fire('Error', value[0], 'error');
          });
          return false;
        } else if (responseFile.hasOwnProperty('codigo') && responseFile.codigo !== 200) {
          Swal.fire('Error', responseFile.mensajes[0], 'error');
          return false;
        }

        var win = window.open(responseFile.guiaEnvio, '_blank');
        win.focus();
      } catch (error) { console.error('Error al descargar el archivo:', error); }
    });
  };

  function ActualizarArticulo() {
    if (props.colDef.validarOpcionesHistorial) props.colDef.actualizararticulo(clikId, clikClave, clikSucursalId);
    else props.colDef.actualizararticulo(clikId);
  }

  function sincronizarExistencia() {
    if (props.colDef.validarOpcionesHistorial) props.colDef.sincronizarExistencia(clikId, clikClave, clikSucursalId);
    else props.colDef.sincronizarExistencia(clikId);
  }

  function sincronizarPrecio() {
    if (props.colDef.validarOpcionesHistorial) props.colDef.sincronizarPrecio(clikId, clikClave, clikSucursalId);
    else props.colDef.sincronizarPrecio(clikId);
  }

  function sincronizarArticulo() {
    props.colDef.sincronizarArticulo(clikId);
  }

  function ActualizarVenta() {
    if (props.colDef.validarOpcionesHistorial) props.colDef.actualizarventa(clikId, clikClave, clikSucursalId);
    else props.colDef.actualizarventa(clikId);
  }

  function PublicarExistencia() {
    if (props.colDef.validarOpcionesHistorial) props.colDef.publicarExistencia(clikId, clikSucursalId);
    else props.colDef.publicarExistencia(clikId);
  }

  function PublicarPrecio() {
    if (props.colDef.validarOpcionesHistorial) props.colDef.publicarPrecio(clikId, clikSucursalId);
    else props.colDef.publicarPrecio(clikId);
  }

  useEffect(() => {
    if (props.colDef.validarOpcionesHistorial) {
      switch (props.row.movimiento) {
        case 'VENTA': {
          setPath(SLUGS.remisiones);
          setOpciones(['vista', 'generarCopia', 'descargarguia', 'actualizarventa']);
          break;
        }
        case 'ARTICULO':
        case 'ARTICULO_STOCK':
        case 'ARTICULO_PRECIO':
        case 'ARTICULO_VARIANTE':
        case 'ARTICULO_VARIANTE_STOCK':
        case 'ARTICULO_VARIANTE_PRECIO': {
          setPath(SLUGS.articulos);
          setOpciones(['editar', 'kardex', 'asignar', 'asignarmanual', 'comparativaArticulo', 'verVariantesArticulo', 'actualizararticulo', 'publicarExistencia', 'publicarPrecio']);
          break;
        }
        default: break;
      }
    }
  }, [props.colDef.validarOpcionesHistorial, props.row.movimiento]);

  return <div>
    <MoreVertIcon id={props.id} key={props.id} variant="contained" onClick={handleClick} />
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      MenuListProps={{ 'aria-labelledby': 'long-button', }}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
    >
      {props.colDef.opciones?.split(',').map((opcion) => {
        if (props.colDef.validarOpcionesHistorial && (opciones.filter(x => x === opcion).length === 0)) return '';

        switch (opcion) {
          case "editar": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton href={path + "/edit/" + clikId}  >
              <EditIcon />&nbsp; Editar
            </ListItemButton>
          </MenuItem>
          case "ver":
            return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
              <ListItemButton href={path + "/ver/" + clikId}  >
                <VisibilityIcon />&nbsp; Ver
              </ListItemButton>
            </MenuItem>
          case "vista": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton href={path + "/view/" + clikId} >
              <VisibilityIcon />&nbsp; Vista
            </ListItemButton>
          </MenuItem>
          case "URLeditar": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton href={props.colDef.UrlEditar + clikId} >
              <EditIcon />&nbsp; Editar
            </ListItemButton>
          </MenuItem>
          case "viewPdf": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.viewPdfOnClick(props.colDef.viewPdf + "?id=" + clikId); handleClose(); }} >
              <EditIcon />&nbsp; Ver factura
            </ListItemButton>
          </MenuItem>
          case "pdf": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { descargarFactura(clikId, props.colDef.viewPdf, clikId + ".pdf"); handleClose(); }} >
              <EditIcon />&nbsp; Descargar PDF
            </ListItemButton>
          </MenuItem>
          case "xml": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { descargarFactura(clikId, props.colDef.xml, clikId + ".xml"); handleClose(); }} >
              <EditIcon />&nbsp; Descargar XML
            </ListItemButton>
          </MenuItem>
          case "MarcarPagado": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.marcarpagado(props.colDef.marcarpagadoUrl + "?fac_id=" + clikId); handleClose(); }} >
              <EditIcon />&nbsp; Marcar como Pagado
            </ListItemButton>
          </MenuItem>
          case "asignar": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.asignarAutomatico(clikId); handleClose(); }} >
              <CompareArrowsIcon />&nbsp; Asignacion automatico
            </ListItemButton>
          </MenuItem>
          case "asignarmanual": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton href={props.colDef.path + '/asignacion/' + clikId} >
              <CompareArrowsIcon />&nbsp; Asignacion Manual
            </ListItemButton>
          </MenuItem>
          case "verVentasArticulo": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verVentasArticulo(clikId); handleClose(); }} >
              <LoyaltyIcon />&nbsp; Ver ventas
            </ListItemButton>
          </MenuItem>
          case "kardex": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verMovimientoArticulo(clikId); handleClose(); }} >
              <LoyaltyIcon />&nbsp; Kardex
            </ListItemButton>
          </MenuItem>
          case "publicarExistencia": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { PublicarExistencia(); handleClose(); }} >
              <LoyaltyIcon />&nbsp; Publicar Existencia
            </ListItemButton>
          </MenuItem>
          case "publicarPrecio": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { PublicarPrecio(); handleClose(); }} >
              <LoyaltyIcon />&nbsp; Publicar Precio
            </ListItemButton>
          </MenuItem>
          case "verVariantesArticulo": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verVariantesArticulo(clikId); handleClose(); }} >
              <LoyaltyIcon />&nbsp; Ver Variantes
            </ListItemButton>
          </MenuItem>
          case "verHistorial": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verHistorial(clikId); handleClose(); }} >
              <LoyaltyIcon />&nbsp; Ver Historial
            </ListItemButton>
          </MenuItem>
          case "descargarguia": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { DescargarGuia(clikId); handleClose(); }} >
              <PrintIcon />&nbsp; Imprimir Etiqueta
            </ListItemButton>
          </MenuItem>
          case "actualizararticulo": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { ActualizarArticulo(); handleClose(); }} >
              <SystemUpdateAltIcon />&nbsp; Actualizar
            </ListItemButton>
          </MenuItem>
          case "sincronizarExistencia": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { sincronizarExistencia(); handleClose(); }} >
              <SystemUpdateAltIcon />&nbsp; Sincronizar Existencia
            </ListItemButton>
          </MenuItem>
          case "sincronizarPrecio": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { sincronizarPrecio(); handleClose(); }} >
              <SystemUpdateAltIcon />&nbsp; Sincronizar Precio
            </ListItemButton>
          </MenuItem>
          case "sincronizarArticulo": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { sincronizarArticulo(); handleClose(); }} >
              <SystemUpdateAltIcon />&nbsp; Sincronizar Articulo
            </ListItemButton>
          </MenuItem>
          case "duplicarArticulo": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.duplicarArticulo(clikId); handleClose(); }} >
              <WebStoriesIcon />&nbsp; Duplicar
            </ListItemButton>
          </MenuItem>
          case "deshabilitar": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.deshabilitar(clikId); handleClose(); }}  >
              <BlockIcon />&nbsp; Deshabilitar
            </ListItemButton>
          </MenuItem>
          case "eliminar": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.eliminar(clikId); handleClose(); }}  >
              <DeleteIcon />&nbsp; Eliminar
            </ListItemButton>
          </MenuItem>
          case "desvincular": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.desvincular(clikId); handleClose(); }}  >
              <MobiledataOffIcon />&nbsp; Desvincular
            </ListItemButton>
          </MenuItem>
          case "generarCopia": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.generarCopia(clikId); handleClose(); }} >
              <WebStoriesIcon />&nbsp; Registrar a principal
            </ListItemButton>
          </MenuItem>
          case "verEntregas": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { handleClose(); }} >
              <LocalShippingIcon />&nbsp; Ver Entregas
            </ListItemButton>
          </MenuItem>
          case "asignarRepartidor": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { handleClose(); }} >
              <AssignmentIndIcon />&nbsp; Asignar Repartidor
            </ListItemButton>
          </MenuItem>
          case "asignarDatosExtraFactura": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.asignarDatosExtraFactura(clikId); handleClose(); }} >
              <AssignmentIcon />&nbsp; Asignar Datos Extra
            </ListItemButton>
          </MenuItem>
          case "verNotasCredito": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verNotasCredito(clikId); handleClose(); }} >
              <RequestQuoteIcon />&nbsp; Ver Notas de credito
            </ListItemButton>
          </MenuItem>
          case "verDetallePago": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verDetallePago(clikId); handleClose(); }} >
              <RequestQuoteIcon />&nbsp; Ver Detalle de Pago
            </ListItemButton>
          </MenuItem>
          case "cancelarAbono":
            if (props.row?.cancelado === 'S') return '';
            return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.cancelarAbono(clikId); handleClose(); }} >
              <BlockIcon />&nbsp; Cancelar Abono
            </ListItemButton>
          </MenuItem>
          case "verVisitas": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verVisitas(clikId); handleClose(); }} >
              <RequestQuoteIcon />&nbsp; Ver Visitas
            </ListItemButton>
          </MenuItem>
          case "verAdeudos": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verAdeudos(clikId); handleClose(); }} >
              <RequestQuoteIcon />&nbsp; Ver Adeudos
            </ListItemButton>
          </MenuItem>
          case "convertirPedido": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.convertirPedido(clikId); handleClose(); }} >
              <RequestQuoteIcon />&nbsp; Convertir a Pedido
            </ListItemButton>
          </MenuItem>
          case "convertirRemision": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.convertirRemision(clikId); handleClose(); }} >
              <RequestQuoteIcon />&nbsp; Surtir y Convertir a Remision
            </ListItemButton>
          </MenuItem>
          case "convertirCompra": {
            if (props.row?.estatus === 'C' || props.row?.estatus === 'T') return <></>;
            return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
              <ListItemButton onClick={() => { props.colDef.convertirCompra(clikId); handleClose(); }} >
                <CompareArrowsIcon />&nbsp; Convertir a compra
              </ListItemButton>
            </MenuItem>
          }
          case "recepcionCompra": {
            if (props.row?.estatus === 'C' || props.row?.estatus === 'T') return <></>;
            return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
              <ListItemButton onClick={() => { props.colDef.recepcionCompra(clikId); handleClose(); }} >
                <InventoryIcon />&nbsp; Recepción compra
              </ListItemButton>
            </MenuItem>
          }
          case "cancelarCompra": {
            if (props.row?.estatus === 'C') return <></>;
            return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
              <ListItemButton onClick={() => { props.colDef.cancelarCompra(clikId); handleClose(); }} >
                <BlockIcon />&nbsp; Cancelar
              </ListItemButton>
            </MenuItem>
          }
          case "verPagos": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verPagos(clikId); handleClose(); }} >
              <RequestQuoteIcon />&nbsp; Ver Pagos
            </ListItemButton>
          </MenuItem>
          case "abonar": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.abonar(clikId); handleClose(); }} >
              <AttachMoneyIcon />&nbsp; Abonar
            </ListItemButton>
          </MenuItem>
          case "asignarAgente": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.asignarAgente(clikId); handleClose(); }} >
              <AssignmentIcon />&nbsp; Asignar Agente
            </ListItemButton>
          </MenuItem>
          case "verVxEntregas": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verVxEntregas(clikId); handleClose(); }} >
              <AssignmentIcon />&nbsp; Ver Entregas
            </ListItemButton>
          </MenuItem>
          case "verEntregasPedido": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.verEntregasPedido(clikId); handleClose(); }} >
              <AssignmentIcon />&nbsp; Ver Entregas
            </ListItemButton>
          </MenuItem>
          case "actualizarventa": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { ActualizarVenta(); handleClose(); }} >
              <SystemUpdateAltIcon />&nbsp; Actualizar
            </ListItemButton>
          </MenuItem>
          case "comparativaArticulo": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton href={SLUGS.diferencia + '/' + clikId}  >
              <CompareArrowsIcon />&nbsp; Comparativa
            </ListItemButton>
          </MenuItem>
          case "enviarVentaERP": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.enviarVentaERP(clikId); handleClose(); }} >
              <WebStoriesIcon />&nbsp; Enviar venta a ERP
            </ListItemButton>
          </MenuItem>
          case "cambiarStatusFull": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.cambiarStatusFull(clikId); handleClose(); }} >
              <WebStoriesIcon />&nbsp; Cambiar estatus FULL
            </ListItemButton>
          </MenuItem>
          case "cambiarFactor": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.cambiarFactor(clikId, clikFactor); handleClose(); }} >
              <AppRegistrationIcon />&nbsp; Cambiar Factor
            </ListItemButton>
          </MenuItem>
          case "activarUsuario": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.activarUsuario(clikId); handleClose(); }} >
              <WebStoriesIcon />&nbsp; Activar Estatus
            </ListItemButton>
          </MenuItem>
          case "activarCuentaUsuario": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.activarCuentaUsuario(clikId); handleClose(); }} >
              <WebStoriesIcon />&nbsp; Activar Cuenta
            </ListItemButton>
          </MenuItem>
          case "enviarLinkActivacion": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.enviarLinkActivacion(clikId); handleClose(); }} >
              <WebStoriesIcon />&nbsp; Enviar correo de activacion
            </ListItemButton>
          </MenuItem>
          case "duplicarArtMatriz": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.duplicarArtMatriz(clikId); handleClose(); }} >
              <WebStoriesIcon />&nbsp; Enviar aticulo a matriz
            </ListItemButton>
          </MenuItem>
          case "asignarExistencias": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.asignarExistencias(clikId); handleClose(); }} >
              <InventoryIcon />&nbsp; Asignar existencia
            </ListItemButton>
          </MenuItem>
          case "asignarPrecios": return <MenuItem style={{ fontSize: "13px !important", padding: "0" }}>
            <ListItemButton onClick={() => { props.colDef.asignarPrecios(clikId); handleClose(); }} >
              <AttachMoneyIcon />&nbsp; Asignar precio
            </ListItemButton>
          </MenuItem>
          default: return <></>;
        }
      })}
    </Menu>
  </div>;
}

export default RenderButtons;
